import React from "react";
import { Navigate, Route, Routes } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login from "../auth/login/login";
import WelcomePage from "../auth/login/WelcomePage";

// Define allowed public routes (not requiring login)
// const allowedWithoutLogin = [
//   "/insurance",
//   "/GPA-key-information",
//   "/my-coverages",
//   "/download-e-card",
//   "/health-insurance-corner",
//   "/premium-eligibility",
//   "/policy-information",
//   "/customer-information-sheet",
//   "/claim-procedures",
//   "/grievance",
// ];

const allowedWithoutLogin = [""];

const ALLRoutes: React.FC = () => {
  const isAuthenticated = localStorage.getItem("login") === "true";
  const hasSeenWelcome = localStorage.getItem("welcomeSeen") === "true";

  return (
    <Routes>
      {isAuthenticated ? (
        <Route element={<Feature />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
      ) : (
        <>
          <Route path="/login" element={<Login />} />
          <Route path="/welcomeUser" element={<WelcomePage />} />

          {publicRoutes.map((route, idx) => (
            <Route
              path="*"
              element={
                hasSeenWelcome ? (
                  <Navigate to="/login" replace />
                ) : (
                  <Navigate to="/welcomeUser" replace />
                )
                // <Navigate to="/login" replace />
              }
            />
          ))}
        </>
      )}

      {/* Authenticated-only routes */}
      <Route element={<AuthFeature />}>
        {authRoutes.map((route, idx) => (
          <Route path={route.path} element={route.element} key={idx} />
        ))}
      </Route>
    </Routes>
  );
};

export default ALLRoutes;
